exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-docs .vs-popup {\n  width: auto !important;\n}", ""]);

// exports
